<template>
  <div
    class="d-flex auth-form-body"
    :style="minHeight ? `min-height:${minHeight}px` : ''"
  >
    <div class="w-50 d-flex align-items-center shadow-lg position-relative">
      <div class="px-5" ref="companyProfile">
        <AuthCompanyProfile />
      </div>
    </div>
    <div class="w-50 d-flex align-items-center auth-suggestion">
      <div class="w-50 mx-auto" ref="authForm">
        <form @submit.prevent="handleSubmit" novalidate>
          <h3 class="mb-4 text-center">რეგისტრაცია</h3>
          <div class="mb-3">
            <label class="form-label">სახელი</label>
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': firstnameError }"
              v-model="firstname"
              @focus="firstnameError = false"
            />
            <div v-if="firstnameError" class="invalid-feedback">
              {{ firstnameErrorMessage }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">გვარი</label>
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': lastnameError }"
              v-model="lastname"
              @focus="lastnameError = false"
            />
            <div v-if="lastnameError" class="invalid-feedback">
              {{ lastnameErrorMessage }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">ელ. ფოსტა</label>
            <input
              type="email"
              class="form-control"
              :class="{ 'is-invalid': emailError }"
              v-model="email"
              @focus="emailError = false"
            />
            <div v-if="emailError" class="invalid-feedback">
              {{ emailErrorMessage }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">სქესი</label>
            <select
              class="form-select"
              v-model="gender"
              :class="{ 'is-invalid': genderError }"
              @focus="genderError = false"
            >
              <option selected style="display: none"></option>
              <option value="მდედრობითი">მდედრობითი</option>
              <option value="მამრობითი">მამრობითი</option>
              <option value="სხვა">სხვა</option>
            </select>
            <div v-if="genderError" class="invalid-feedback">
              {{ genderErrorMessage }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">ასაკი</label>
            <select
              class="form-select"
              v-model="age"
              :class="{ 'is-invalid': ageError }"
              @focus="ageError = false"
            >
              <option selected style="display: none"></option>
              <option value="18 წლამდე">18 წლამდე</option>
              <option value="18-24">18-24</option>
              <option value="25-44">25-44</option>
              <option value="45-60">45-60</option>
              <option value="60">60 ></option>
            </select>
            <div v-if="ageError" class="invalid-feedback">
              {{ ageErrorMessage }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">ორგანიზაცია</label>
            <select
              class="form-select"
              v-model="organisation"
              :class="{ 'is-invalid': organisationError }"
              @focus="organisationError = false"
            >
              <option selected style="display: none"></option>
              <option value="სამთავრობო">სამთავრობო</option>
              <option value="არასამთავრობო">არასამთავრობო</option>
              <option value="კერძო სექტორი">კერძო სექტორი</option>
              <option value="სხვა">სხვა</option>
            </select>
            <div v-if="organisationError" class="invalid-feedback">
              {{ organisationErrorMessage }}
            </div>
          </div>
          <div class="mb-3 position-relative">
            <label class="form-label">პაროლი</label>
            <input
              :type="showPassword ? 'text' : 'password'"
              class="form-control"
              :class="{ 'is-invalid': passwordError }"
              v-model="password"
              @focus="passwordError = false"
            />
            <div class="show-password" @click="showPassword = !showPassword">
              <span v-if="!showPassword" class="material-icons text-secondary">
                visibility
              </span>
              <span v-if="showPassword" class="material-icons text-secondary">
                visibility_off
              </span>
            </div>
            <div v-if="passwordError" class="invalid-feedback">
              {{ passwordErrorMessage }}
            </div>
          </div>
          <div class="mb-3 position-relative">
            <label class="form-label">გაიმეორეთ პაროლი</label>
            <input
              :type="showPassword ? 'text' : 'password'"
              class="form-control"
              :class="{ 'is-invalid': passwordConfirmError }"
              v-model="passwordConfirm"
              @focus="passwordConfirmError = false"
            />
            <div v-if="passwordConfirmError" class="invalid-feedback">
              {{ passwordConfirmErrorMessage }}
            </div>
          </div>
          <div v-if="serverError" class="alert alert-danger mb-3" role="alert">
            {{ serverErrorMessage }}
          </div>
          <div class="text-center mb-4">
            <button
              type="submit"
              class="btn btn-primary rounded-pill px-4 font-caps"
            >
              რეგისტრაცია
            </button>
          </div>
        </form>
        <div class="text-center">
          გაიარეთ
          <router-link :to="{ name: 'signin' }" class="text-decoration-none"
            >ავტორიზაცია</router-link
          >
          თუ უკვე გაქვთ ანგარიში
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import AuthCompanyProfile from "@/components/AuthCompanyProfile.vue";
import useAuthMinHeight from "@/composables/useAuthMinHeight";

export default {
  components: { AuthCompanyProfile },
  setup() {
    const store = useStore();

    const router = useRouter();

    const firstname = ref("");
    const lastname = ref("");
    const email = ref("");
    const gender = ref("");
    const age = ref("");
    const organisation = ref("");
    const password = ref("");
    const passwordConfirm = ref("");

    const firstnameError = ref(false);
    const firstnameErrorMessage = ref("");
    const lastnameError = ref(false);
    const lastnameErrorMessage = ref("");
    const emailError = ref(false);
    const emailErrorMessage = ref("");
    const genderError = ref(false);
    const genderErrorMessage = ref("");
    const ageError = ref(false);
    const ageErrorMessage = ref("");
    const organisationError = ref(false);
    const organisationErrorMessage = ref("");
    const passwordError = ref(false);
    const passwordErrorMessage = ref("");
    const passwordConfirmError = ref(false);
    const passwordConfirmErrorMessage = ref("");
    const serverError = ref(false);
    const serverErrorMessage = ref("");

    const { minHeight, companyProfile, authForm } = useAuthMinHeight();

    const showPassword = ref(false);

    const handleSubmit = async () => {
      if (firstname.value.length === 0) {
        firstnameError.value = true;
        firstnameErrorMessage.value = "სახელის ველი ცარიელია";
      }

      if (lastname.value.length === 0) {
        lastnameError.value = true;
        lastnameErrorMessage.value = "გვარის ველი ცარიელია";
      }

      if (email.value.length === 0) {
        emailError.value = true;
        emailErrorMessage.value = "ელ. ფოსტის ველი ცარიელია";
      } else if (!/\S+@\S+\.\S+/.test(email.value)) {
        emailError.value = true;
        emailErrorMessage.value = "ელ. ფოსტის მისამართი არსწორია";
      }

      if (gender.value.length === 0) {
        genderError.value = true;
        genderErrorMessage.value = "მიუთითეთ სქესი";
      }

      if (age.value.length === 0) {
        ageError.value = true;
        ageErrorMessage.value = "მიუთითეთ ასაკი";
      }

      if (organisation.value.length === 0) {
        organisationError.value = true;
        organisationErrorMessage.value = "მიუთითეთ ორგანიზაცია";
      }

      if (password.value.length < 6) {
        passwordError.value = true;
        passwordErrorMessage.value = "პაროლი მინიმუმ უნდა შეიცავდეს 6 სიმბოლოს";
      }

      if (passwordConfirm.value.length === 0) {
        passwordConfirmError.value = true;
        passwordConfirmErrorMessage.value =
          "განმეორებითი პაროლის ველი ცარიელია";
      } else if (passwordConfirm.value !== password.value) {
        passwordConfirmError.value = true;
        passwordConfirmErrorMessage.value =
          "განმეორებითი პაროლი არ ემთხვევა პაროლს";
      }

      if (
        !emailError.value &&
        !passwordError.value &&
        !firstnameError.value &&
        !lastnameError.value &&
        !genderError.value &&
        !ageError.value &&
        !organisationError.value
      ) {
        try {
          await store.dispatch("signup", {
            email: email.value,
            password: password.value,
            firstname: firstname.value,
            lastname: lastname.value,
            gender: gender.value,
            age: age.value,
            organisation: organisation.value,
          });

          router.push({ name: "home" });
        } catch (error) {
          serverError.value = true;
          serverErrorMessage.value = error.message;
        }
      } else {
        serverError.value = false;
      }
    };

    return {
      firstname,
      lastname,
      email,
      gender,
      age,
      organisation,
      password,
      passwordConfirm,
      handleSubmit,
      firstnameError,
      firstnameErrorMessage,
      lastnameError,
      lastnameErrorMessage,
      emailError,
      emailErrorMessage,
      genderError,
      genderErrorMessage,
      ageError,
      ageErrorMessage,
      organisationError,
      organisationErrorMessage,
      passwordError,
      passwordErrorMessage,
      passwordConfirmError,
      passwordConfirmErrorMessage,
      serverError,
      serverErrorMessage,
      showPassword,
      companyProfile,
      authForm,
      minHeight,
    };
  },
};
</script>

<style>
</style>